'use strict';

var lockedScrollPosition = 0;
(function($) {

    var Defaults = $.fn.select2.amd.require('select2/defaults');

    $.extend(Defaults.defaults, {
        dropdownPosition: 'auto'
    });

    var AttachBody = $.fn.select2.amd.require('select2/dropdown/attachBody');

    var _positionDropdown = AttachBody.prototype._positionDropdown;

    AttachBody.prototype._positionDropdown = function() {

        var $window = $(window);

        var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
        var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');

        var newDirection = null;

        var offset = this.$container.offset();

        offset.bottom = offset.top + this.$container.outerHeight(false);

        var container = {
            height: this.$container.outerHeight(false)
        };

        container.top = offset.top;
        container.bottom = offset.top + container.height;

        var dropdown = {
            height: this.$dropdown.outerHeight(false)
        };

        var viewport = {
            top: $window.scrollTop(),
            bottom: $window.scrollTop() + $window.height()
        };

        var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
        var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);

        var css = {
            left: offset.left,
            top: container.bottom
        };

        // Determine what the parent element is to use for calciulating the offset
        var $offsetParent = this.$dropdownParent;

        // For statically positoned elements, we need to get the element
        // that is determining the offset
        if ($offsetParent.css('position') === 'static') {
            $offsetParent = $offsetParent.offsetParent();
        }

        var parentOffset = $offsetParent.offset();

        css.top -= parentOffset.top
        css.left -= parentOffset.left;

        var dropdownPositionOption = this.options.get('dropdownPosition');

        if (dropdownPositionOption === 'above' || dropdownPositionOption === 'below') {

            newDirection = dropdownPositionOption;

        } else {

            if (!isCurrentlyAbove && !isCurrentlyBelow) {
                newDirection = 'below';
            }

            if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
                newDirection = 'above';
            } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
                newDirection = 'below';
            }

        }

        if (newDirection == 'above' ||
            (isCurrentlyAbove && newDirection !== 'below')) {
            css.top = container.top - parentOffset.top - dropdown.height;
        }

        if (newDirection != null) {
            this.$dropdown
                .removeClass('select2-dropdown--below select2-dropdown--above')
                .addClass('select2-dropdown--' + newDirection);
            this.$container
                .removeClass('select2-container--below select2-container--above')
                .addClass('select2-container--' + newDirection);
        }

        this.$dropdownContainer.css(css);

    };

})(window.jQuery);

$(document).ready(function () {
    /* Tabs */
    const tabs = document.querySelectorAll('.tab');
    const tabContent = document.querySelectorAll('.tab-pane');

    function showTab(index) {
        tabs.forEach(tab => tab.classList.remove('active'));
        tabContent.forEach(pane => pane.classList.remove('active'));

        tabs[index].classList.add('active');
        tabContent[index].classList.add('active');
    }

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            showTab(index);
        });
    });
    /* END Tabs */

    $( '.homepage-slider__numbers span:last-child' ).html( $( '.flip-slide' ).length );

    $('.js-flip-slider-nav').on('init', function(slick){
        var slideWith = $( '.flip-slide__side' )[0].offsetWidth / 3 * 4;
        $( '.flip-slider-nav' ).css({ 'margin-right':  '-'+ slideWith + 'px', 'width': 'calc(50% + ' + slideWith +'px)' });
    });


    $( '.js-flip-slider-nav' ).slick({
        loop: true,
        rtl: true,
        dots: false,
        infinite: true,
        speed: 700,
        slidesToShow: 4,
        swipeToSlide: true,
        touchThreshold: 20,
        slidesToScroll: 1,
        asNavFor: '.js-flip-slider',
        arrows: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1201,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $( '.js-flip-slider' ).slick({
        dots: false,
        infinite: true,
        fade: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.flip-slider-nav',
        arrows: false
    });

    $('.js-flip-slider').on('afterChange', function(slick, currentSlide){
        let cS = currentSlide.currentSlide + 1;
        if (cS < 10) {
            $( '.homepage-slider__numbers span.number--active' ).html( '0' + cS );
        } else {
            $( '.homepage-slider__numbers span.number--active' ).html( cS );
        }
    });

    $( 'body' ).on( 'click', '.js-flip-arrow--prev', function() {
        $( '.js-flip-slider' ).slick('slickPrev');
    });

    $( 'body' ).on( 'click', '.js-flip-arrow--next', function() {
        $( '.js-flip-slider' ).slick('slickNext');
    });


    $('body').addClass('ready');
    function svgMap() {
        const mapFrame = $('.map__frame');
        const mapFrameWidth = mapFrame.width();

        mapFrame.find('svg').attr('width', mapFrameWidth)
    }

    svgMap()


    $('.js-resetBtn').on('click', function() {
        $(this).closest('form').find('select').val(null).trigger("change");
    });

    $( 'body' ).on('change', '.vacancy-file input[type="file"]', function() {
        if ( $( this ).val() !== '' ) {
            let path = $( this ).val().split('\\')
            $( this ).closest( 'form' ).find('.vacancy-file').addClass('filled');
            $( this ).closest( 'form' ).find('.vacancy-file-filled__val').text(path[path.length - 1]);
        } else {
            $( this ).closest( 'form' ).find('.vacancy-file').addClass('filled');
            $( this ).closest( 'form' ).find('.vacancy-file-filled__val').text('');
        }
    });

    $( 'body' ).on('click', '.vacancy-file-filled__delete', function() {
        $( this ).closest( 'form' ).find('.vacancy-file').removeClass('filled');
        $( this ).closest( 'form' ).find('.vacancy-file-filled__val').text('');
    });

    gsap.registerPlugin(ScrollTrigger);

    //scroll
    let Scrollbar,
        scrollbar;
    Scrollbar = window.Scrollbar;

    function disableScroll() {
        Scrollbar.ScrollbarPlugin.apply(this, arguments);
    }
    disableScroll.prototype = Object.create(Scrollbar.ScrollbarPlugin.prototype);



    disableScroll.prototype.transformDelta = function(delta) {
        if (this.options.direction) {
            delta[this.options.direction] = 0;
        }

        return { ...delta };
    };

    disableScroll.pluginName = 'disableScroll';
    disableScroll.defaultOptions = {
        direction: '',
    };

    $('select').select2({
        language: 'en',
        width: '100%',
        minimumResultsForSearch: -1,
        dropdownParent: $('.wrapper'),
        dropdownPosition: 'below',
    });

    $('select').on('select2:open', function() {
        var $select2Dropdown = $('.wrapper > .select2-container--open');

        if (scrollbar) {
            lockedScrollPosition = scrollbar.offset.y;

            $( 'body' ).on( 'mouseover', '.select2-results__options', function(){
                lockedScrollPosition = scrollbar.offset.y;
            });

            $( 'body' ).on( 'wheel', '.select2-results__options', function(e){
                scrollbar.scrollTo(0, lockedScrollPosition, 1000);
                $( this ).scrollTop($( this ).scrollTop() + e.originalEvent.deltaY);
            });
        }
        if ($(window).outerWidth() < 576) {
            function updateDropdownPosition() {
                $select2Dropdown.css('top', scrollbar.scrollTop + ($(window).outerHeight() - $select2Dropdown.find('.select2-dropdown').outerHeight()));

                var select2Results = document.querySelectorAll('.select2-results__options');

                select2Results.forEach(function(element) {
                    element.addEventListener('touchmove', function(event) {
                        event.stopPropagation();
                    });
                });
            }

            setTimeout(function () {
                updateDropdownPosition();
            },1)

            scrollbar.addListener(updateDropdownPosition);
        }
    });

    var vacancyPopup = document.querySelector('#vacancy_popup');
    if (vacancyPopup) {
        Scrollbar.init(vacancyPopup);
    }

    var talentPopup = document.querySelector('#talent_popup');
    if (talentPopup) {
        Scrollbar.init(talentPopup);
    }

    function MobilePlugin() {
        Scrollbar.ScrollbarPlugin.apply(this, arguments);
    }

    MobilePlugin.prototype = Object.create(Scrollbar.ScrollbarPlugin.prototype);

    MobilePlugin.prototype.transformDelta = function(delta, fromEvent) {
        if (fromEvent.type !== 'touchend') {
            return delta;
        }

        return {
            x: delta.x * this.options.speed,
            y: delta.y * this.options.speed
        };
    };

    MobilePlugin.pluginName = 'mobile';
    MobilePlugin.defaultOptions = {
        speed: 0.5,
    };

    Scrollbar.use(disableScroll);
    Scrollbar.use(MobilePlugin);



    function checkNavMenu() {
        const menu = $('.header-nav__body-menu ol');
        const tabletHeaderMenu = $('.header-nav__body');
        const tabletHeaderMenuHeight = tabletHeaderMenu.outerHeight(true);
        const li = menu.find('li');

        const menuHeight = li.outerHeight(true) * li.length
        const windowHeight = window.innerHeight;

        const headerTop = $('.header-nav__head');

        if ( window.innerWidth < 1100 && window.innerWidth > 575 ) {
            Scrollbar.init(document.querySelector('.header-nav__body'), {
                plugins: {
                    disableScroll: {
                        direction: 'x'
                    }
                }
            });
        } else {
            Scrollbar.destroy(document.querySelector('.header-nav__body'));
        }

        if (  window.innerWidth > 1100 && (menuHeight + headerTop.outerHeight(true)) > windowHeight ) {
            Scrollbar.init(document.querySelector('.header-nav__body-menu ol'), {
                plugins: {
                    disableScroll: {
                        direction: 'x'
                    }
                }
            });
        } else {
            Scrollbar.destroy(document.querySelector('.header-nav__body-menu ol'));

        }
    }

    function checkScroll() {

        if ( !scrollbar ) {
            scrollbar = Scrollbar.init(document.querySelector('.js-scroll'), {
                damping: 0.05,
                delegateTo: document,
                continuousScrolling: true,
                plugins: {
                    mobile: {
                        speed: 0.7
                    }
                }
            });
        }

        if (window.innerWidth < 1100) {
            Scrollbar.use(MobilePlugin);
        }
        ScrollTrigger.scrollerProxy(".js-scroll", {
            scrollTop(value) {
                if (arguments.length) {
                    scrollbar.scrollTop = value;
                }
                return scrollbar.scrollTop;
            },
        });

        scrollbar.addListener(ScrollTrigger.update);
        ScrollTrigger.defaults({ scroller: '.js-scroll' });
        ScrollTrigger.refresh()
    }
    checkScroll();
    checkNavMenu()

    function progressBarInit() {
        const $progressBar = $('.progress-bar');
        const $sectionTitles = $('.section__title');

        const offsetLeft = $('.js-intro-title').offset().left;
        const titleOffsetTop = $('.js-intro-title').offset().top;
        const containerPadding = parseInt($('.js-intro-section > .container').css('padding-left'))
        const linePos = offsetLeft - (containerPadding / 2);

        $progressBar.css({
            'left': `${linePos}px`,
            'opacity': `1`
        });

        let maxHeight;
        let titlesOffsets = [];
        let titleLineHeightSpace = 42;

        if (window.innerWidth < 767) {
            titleLineHeightSpace = 25;
        }

        if (window.innerWidth < 575) {
            titleLineHeightSpace = 10;
        }
        let initHeight = $('.section__title p:first-child').height() - titleLineHeightSpace;

        TweenMax.to($progressBar, 2, {
            height: initHeight,
            ease: Back.easeIn
        })
        if (!$(document).find('.level').length) {
            $sectionTitles.each(function (index) {
                const title = $(this);
                let progressPointBG = '';
                title.data( 'bg' ) ? progressPointBG = title.data( 'bg' ) : progressPointBG = '';
                if ( index === 0 ) {
                    initHeight = title.find('p:first').height() - titleLineHeightSpace;
                    const firstTitlePosBottom = title.offset().top;

                    titlesOffsets.push(firstTitlePosBottom)
                } else {
                    const titleOffset = title.offset().top;
                    titlesOffsets.push(titleOffset);

                    const val = index;
                    $progressBar.append(`<div class="level" data-bg="${progressPointBG}" style="top: ${(titlesOffsets[ index ] - $progressBar.offset().top)}px;" data-sub-lvl="${val}"><span>${val}</span></div>`);
                }

            })
        } else {
            $sectionTitles.each(function (index) {
                const title = $(this);

                if ( index === 0 ) {
                    initHeight = title.find('p:first').height() - 24;
                    const firstTitlePosBottom = title.offset().top;
                    titlesOffsets.push(firstTitlePosBottom)
                } else {
                    const titleOffset = title.offset().top;
                    titlesOffsets.push(titleOffset);

                }
            })

            $('.level').each(function (index) {
                $(this).css("top", `${(titlesOffsets[ index + 1 ] - $progressBar.offset().top)}px`);

            })


        }



        maxHeight = titlesOffsets[titlesOffsets.length - 1] - titlesOffsets[0];

        $progressBar.css('max-height', maxHeight);

        if ( $('.js-scroll > .scroll-content').length ) {
            scrollbar.addListener(({ offset }) => {
                progressBarFill($progressBar, offset.y, maxHeight, true);
            });

        }

        const progressBarStartHeight = $progressBar.height();
        const progressBarStartPos = $progressBar.offset().top;
        const progressBarBottom = progressBarStartPos + progressBarStartHeight;
        const levelMarks = gsap.utils.toArray('.level')

        gsap.set(levelMarks, {
            autoAlpha: 0,
        });
        levelMarks.forEach((el, i) => {
            gsap.to(el, {
                scrollTrigger: {
                    trigger: el,
                    pinType: 'transform',
                    start: "top 50%",
                },
                autoAlpha: 1
            })
        })


        if (document.querySelector('.gsap-marker-scroller-start')) {
            const markers = gsap.utils.toArray('[class *= "gsap-marker"]');
            scrollbar.addListener(({ offset }) => gsap.set(markers, { marginTop: -offset.y }));
        }

        function progressBarFill($this, offset = 0, maxHeight = 0, isScroll = false ) {
            const windowOffsetCenter = (offset + ($(window).height() / 2)) ;

            if (windowOffsetCenter > progressBarBottom ) {
                TweenMax.to($progressBar, 1, {
                    height: windowOffsetCenter - progressBarStartPos
                })
            } else {
                TweenMax.to($progressBar, 1, {
                    height: progressBarStartHeight
                })
            }
        }

    }
    function headerItemsAnimation() {


        gsap.from('.header-nav__body-info', 1, {
            autoAlpha: 0,
            delay: 1,
            duration: 1.5,
        })
        gsap.from('.header-nav__body-menu', 1.5,{
            autoAlpha: 0,
            delay: .3,
            y: 1000,
            ease: "power4.out"
        })

    }


    $(window).on('resize', function () {
            svgMap();
            checkScroll();
            checkNavMenu();

    })


    function headerCheck() {
        if (window.innerWidth > 1100) {
            $('.header__container > div').removeClass('header--mobile');
            $('.header__container > div').addClass('header--desktop');
        } else {
            $('.header__container > div').addClass('header--mobile');
            $('.header__container > div').removeClass('header--desktop');
        }

    }
    headerCheck()
    $( window ).on( 'resize', function() {
        headerCheck();
    });

    function anchors(link) {
        if ( $('.header-nav').hasClass('active') ) {
            $('.header-nav').removeClass('active');
            $('.js-scroll > .scroll-content').removeClass('lock');
            $('body').removeClass('lock');
            progressBarInit()
        }

        if ( $('.js-scroll > .scroll-content').length ) {
            const href = link.attr('data-href');
            const $target = $(href);
            scrollbar.scrollTo(0,($target.find('.section__title').offset().top - 40), 4000);
        }
    }
    $(document).on('click', '.anchor', function (e) {
        anchors($(this))
    });

    $(document).on('click', '.js-nav-toggler', function (evt) {
        $('.header-nav').addClass('active');
        $('.js-scroll > .scroll-content').addClass('lock');
        $('body').addClass('lock');

            headerItemsAnimation()
            progressBarInit()
            checkNavMenu()

    });
    $(document).on('click', '.js-close-btn', function (evt) {
        $('.header-nav').removeClass('active');
        $('.js-scroll > .scroll-content').removeClass('lock');
        $('body').removeClass('lock');

            progressBarInit()
            checkNavMenu()

    });

    $('.header__button[data-url]').on('click',function(){
        let url = $(this).data('url'),
            target = $(this).data('target');
        if( target != '' && target !== undefined )
            window.open(url);
        else if (url.indexOf('#') !== -1) {
            let hash = '#' + url.split('#')[1];
            scrollToHash(hash);
        }else
            location.href = url;
        if($('.header-nav.active').length)
            $('.header-nav__button.js-close-btn').click();
    });

    function scrollToHash(hash) {
        setTimeout( function() {
            if ( $('.js-scroll > .scroll-content').length ) {
                const $target = $(hash);
                if($target.length) {
                    if (hash =='#video') {
                        scrollbar.scrollTo(0,(Math.abs($('.scroll > .scroll-content').offset().top) + $target.find('.media-video-poster').offset().top), 4000);
                    }else {
                        scrollbar.scrollTo(0,(Math.abs($('.scroll > .scroll-content').offset().top) + $target.find('.section__title').offset().top - 40), 4000);
                    }
                }
            }
        }, 100);
    }
    scrollToHash(window.location.hash);
    $(document).on('click', '.header-nav__body-menu a', function(e) {
        const url = $(this).attr('href');
        if (url.indexOf('#') !== -1) {
            if ( window.location.pathname === '/' || window.location.pathname === '' ) {
                e.preventDefault();
                const hash = '#' + url.split('#')[1];

                if ( $('.header-nav').hasClass('active') ) {
                    $('.header-nav').removeClass('active');
                    $('.js-scroll > .scroll-content').removeClass('lock');
                    $('body').removeClass('lock');
                    progressBarInit()
                }

                scrollToHash(hash)
            }
        }
    });

    if ( $('.media-video-poster').length ) {

    setTimeout(function () {
        const $bigBall = $('.media-video-control-button')[0];

        $(document).on('click', '.video:not(.video-play)', onClickPlay);
        $(document).on('click', '.video.video-play', onClickPause);
        $('video').on('ended', onVideoEnd);

        function onClickPause(e) {
            const $wrapper = $(this);
            $wrapper.removeClass('video-play');

            $wrapper.find('.media-video-control-button span').html('Play');
            $wrapper.find('video').trigger('pause');

            TweenMax.to($wrapper.find('.media-video-control-button'), .5, {
                opacity: 1
            })
        }
        function onVideoEnd(e) {
            const $wrapper = $(this).closest('.video');
            $wrapper.removeClass('video-play');
            $wrapper.find('.media-video-control-button span').html('Repeat');
            $wrapper.find('.media-video-poster-bg, .video__title').animate({opacity: '1'}, {duration: 300})
        }
        function onClickPlay(e) {
            const $wrapper = $(this).closest('.video');
            $wrapper.addClass('video-play');
            $wrapper.find('.media-video-poster-bg, .video__title').animate({opacity: '0'}, {duration: 300})
            $wrapper.find('.media-video-control-button span').html('Pause');
            $wrapper.find('video').trigger('play');

            TweenMax.to($wrapper.find('.media-video-control-button'), .5, {
                opacity: 0
            })

        }
        function onMouseMove(e) {
            const pos = $(this).closest('.scroll-content').offset();
            const elem_left = pos.left;
            const elem_top = pos.top;
            const innerX = e.pageX - elem_left;
            const innerY = e.pageY - elem_top;
            TweenMax.to($bigBall, .5, {
                position: "fixed",
                opacity: 1,
                x: innerX - 50,
                y: innerY - 50,
                top: "0",
                left: "0"
            })
        }
        function onMouseOut(e) {
            TweenMax.to($bigBall, .7, {
                opacity: 0,
            })
        }
    },1000)

    }

    if ( $('.js-homepage-slider').length ) {

        const $slickElement = $('.js-homepage-slider');

        $slickElement.each(function () {
            const slider = $(this);

            const $status = slider.parent().find('.homepage-slider__numbers');
            slider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
                const i = (currentSlide ? currentSlide : 0) + 1;
                const newI = i < 10 ? '0' + i : i;
                const dataUrl = slider.find('.slick-current > .homepage__slider-item').attr('data-url');
                const companyUrl = slider.find('.slick-current > .homepage__slider-item').attr('data-company-url');


                if ( slider.parent().find('.homepage__slider-item--link.company-link').length ) {
                    if (!dataUrl.length) {
                        slider.parent().find('.homepage__slider-item--link').fadeOut(300);
                    } else {
                        slider.parent().find('.homepage__slider-item--link').fadeIn(300);
                        slider.parent().find('.homepage__slider-item--link').attr('href', dataUrl);

                        const dataUrlTarget = slider.find('.slick-current > .homepage__slider-item').attr('data-url-target');
                        if (!!dataUrlTarget) {
                            slider.parent().find('.homepage__slider-item--link').attr('target', dataUrlTarget);
                        }
                    }

                    if (!companyUrl.length ) {
                        slider.parent().find('.homepage__slider-item--link.company-link').fadeOut(300);
                    } else {
                        slider.parent().find('.homepage__slider-item--link.company-link').fadeIn(300);
                        slider.parent().find('.homepage__slider-item--link.company-link').attr('href', companyUrl);
                    }
                }


                $status.html('<span class="number--active">'+ newI +'</span>' + '<span>' + '/' + slick.slideCount + '</span>');
            });

            slider.slick({
                infinite: false,
                fade: true,
                speed: 700,
                arrows: true,
                dots: true,
                slidesToShow: 1,
                appendDots: slider.parent().find('.homepage-slider__dots'),
                appendArrows: slider.parent().find('.homepage-slider__controls .homepage-slider__arrows'),
                prevArrow: '<div class="homepage-slider__arrow--prev flex --just-center --align-center">\n' +
                    '          <i class="">' +
                    '<svg class="desktop-arrow" width="8" height="23" viewBox="0 0 8 23" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M7.99938 0.000732422L0.17119 11.0385L0 11.119L0.0570634 11.1994L0 11.2799L0.17119 11.3603L7.99938 22.3981V19.5228L2.09628 11.1994L7.99938 2.87603V0.000732422Z" fill="white"/>\n' +
                    '</svg>\n' +
                    '<svg class="mobile-arrow" width="13" height="25" viewBox="0 0 13 25" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M12.2235 23.3334L1.66797 12.5L12.2235 1.66671" stroke="white" stroke-width="2"/>\n' +
                    '</svg>\n' +
                    '</i>\n' +
                    '        </div>',
                nextArrow: '<div class="homepage-slider__arrow--next flex --just-center --align-center">\n' +
                    '          <i class="">' +
                    '<svg class="desktop-arrow" width="8" height="23" viewBox="0 0 8 23" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M0.00062418 0.000732422L7.82881 11.0385L8 11.119L7.94294 11.1994L8 11.2799L7.82881 11.3603L0.00062418 22.3981V19.5228L5.90372 11.1994L0.00062418 2.87603V0.000732422Z" fill="white"/>\n' +
                    '</svg>\n' +
                    '<svg class="mobile-arrow" width="13" height="25" viewBox="0 0 13 25" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M0.776475 23.3334L11.332 12.5L0.776477 1.66671" stroke="white" stroke-width="2"/>\n' +
                    '</svg>\n' +
                    '</i>\n' +
                    '        </div>'
            })

        })

    }

    if ( $('.mobile_input').length ) {

       const inputInstall = $('.mobile_input').intlTelInput( {
            initialCountry: "auto",
            separateDialCode: false,
            allowDropdown: true,
            geoIpLookup: function(callback) {
                 $.get('https://json.geoiplookup.io/', function() {}, "jsonp").always(function(resp) {
                     const countryCode = (resp && resp.country_code) ? resp.country_code : "us";
                     callback(countryCode);
                 });
             },
             utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js"
        });
        inputInstall.promise().done(function () {

            if (!$('body').hasClass('iti-mobile'))    {

                $('.iti__selected-flag').after('<div class="js-dropdown-scroll"></div>');

                $('.js-dropdown-scroll').each(function() {
                    const drp = $(this)
                    drp.append(drp.parent().find( '.iti__country-list' ))

                   setTimeout(function () {
                    Scrollbar.init(drp.get(0));
                    },10)
                })


            } else {
                $(document).on('click', '.iti__selected-flag', function () {

                    setTimeout(function () {
                        Scrollbar.init(document.querySelector('.iti--container .iti__country-list'));
                    },200)
                })
            }



            $(document).on('click', '.iti__country', function (evt) {
                const $country = $(this)
                const countryCode = $country.find('.iti__dial-code').text();

                const input = $('.mobile_input');

                input.val(countryCode);
            })

            setTimeout(function () {
                const activeCountry = $(document).find('.iti__selected-flag').prop('title').replace(/:\s+([^\n]+)/, '');
                const input = $('.mobile_input');
                let dropdownCountry,
                    dropdownActiveCountryCode;

                if ( $('body').hasClass('iti-mobile') ) {
                    dropdownCountry = $(document).find('.iti__selected-flag').prop('title')
                    dropdownActiveCountryCode = dropdownCountry.replace(/^.*?(?=\+)/, '')

                    input.val(dropdownActiveCountryCode);
                } else {
                    dropdownCountry = $(document).find('.iti__country-list .iti__country > .iti__country-name');

                    dropdownCountry.each(function () {
                        if ( $(this).text() == activeCountry ) {
                            dropdownActiveCountryCode = $(this).closest('.iti__country').find('.iti__dial-code').text();

                            input.val(dropdownActiveCountryCode);

                        }
                    })
                }
            },1500)
        })

    }

    $(document).on('click', '.popup--close', popupClose);

    function popupClose() {
        $('.thankyou-popup').removeClass('active');
        $('.popup-overlay').removeClass('active');
        $('.form-popup').removeClass('active');
    }

    if ( $('.form-popup').length ) {
        $(document).on('click', '.js-contact-popup button', function() {
            $('.header-nav').removeClass('active');
            $('.scroll-content').removeClass('lock');
            $('.form-popup:not(.form-success-popup):not(.form-vacancy-popup):not(.form-talent-popup)').addClass('active');
            $('.popup-overlay').addClass('active');
        });
        $(document).on('click', '.js-vacantion-popup', function(event) {
            event.preventDefault();
            $('.header-nav').removeClass('active');
            $('.scroll-content').removeClass('lock');
            $('.form-vacancy-popup').addClass('active');
            $('.popup-overlay').addClass('active');
        });
        $(document).on('click', '.js-popup-talent', function(event) {
            event.preventDefault();
            $('.header-nav').removeClass('active');
            $('.scroll-content').removeClass('lock');
            $('.form-talent-popup').addClass('active');
            $('.popup-overlay').addClass('active');
        });
    }

    if ( $('.js-news-slider').length ) {
        const $slickElement = $('.js-news-slider');

        $slickElement.each(function() {
            const slider = $(this);
            slider.slick({
                infinite: true,
                fade: true,
                speed: 700,
                arrows: true,
                dots: false,
                slidesToShow: 1,

                appendArrows: slider.parent().find('.section__head .news__arrows-wrapper'),
                prevArrow: '<div class="news-slider__arrow--prev flex --just-center --align-center">\n' +
                    '          <i class="">' +
                    '<svg class="desktop-arrow" width="8" height="23" viewBox="0 0 8 23" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M7.99938 0.000732422L0.17119 11.0385L0 11.119L0.0570634 11.1994L0 11.2799L0.17119 11.3603L7.99938 22.3981V19.5228L2.09628 11.1994L7.99938 2.87603V0.000732422Z" fill="white"/>\n' +
                    '</svg>\n' +
                    '<svg class="mobile-arrow" width="13" height="25" viewBox="0 0 13 25" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M12.2235 23.3334L1.66797 12.5L12.2235 1.66671" stroke="white" stroke-width="2"/>\n' +
                    '</svg>\n' +
                    '</i>\n' +
                    '        </div>',
                nextArrow: '<div class="news-slider__arrow--next flex --just-center --align-center">\n' +
                    '          <i class="">' +
                    '<svg class="desktop-arrow" width="8" height="23" viewBox="0 0 8 23" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M0.00062418 0.000732422L7.82881 11.0385L8 11.119L7.94294 11.1994L8 11.2799L7.82881 11.3603L0.00062418 22.3981V19.5228L5.90372 11.1994L0.00062418 2.87603V0.000732422Z" fill="white"/>\n' +
                    '</svg>\n' +
                    '<svg class="mobile-arrow" width="13" height="25" viewBox="0 0 13 25" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M0.776475 23.3334L11.332 12.5L0.776477 1.66671" stroke="white" stroke-width="2"/>\n' +
                    '</svg>\n' +
                    '</i>\n' +
                    '        </div>'

            })
        })



    }

    if ( $('.js-flip-slider').length ) {
        const $flipSlider = $('.js-flip-slider');
        ///
    }

    function copyUrl(button) {

        const currentUrl = window.location.href;

        navigator.clipboard.writeText(currentUrl);

        button.css('background-color', "#E88936")

        setTimeout(function () {
            button.css('background-color', "")
        }, 2000);

     }

    function socialSharing() {
        //fixed sharing

        if ( window.innerWidth > 1100 ) {
            const sharingWrapper = $('.article-socials-wrapper');
        const startPos = $('.article-content').offset().top;
        const endPos =  $('.article-content').innerHeight();

        scrollbar.addListener(({ offset }) => {

            if ( offset.y > startPos && (offset.y + sharingWrapper.height()) < endPos ) {

                 const transform = offset.y - startPos;
                 const windowHalf = (window.innerHeight / 2) +  sharingWrapper.height()

                 gsap.to('.article-socials-wrapper', {
                    y: transform + 100,
                })

            }

            if ( offset.y === 0 ) {
                gsap.to('.article-socials-wrapper', {
                    y: 0
                })
            }

        });
        }

        $(document).on('click', '.share-button', function(evt) {
            const btn = $(this);

            if ( btn.hasClass('share-copylink') ) {
                copyUrl(btn)
            }

        });

    }



    if ( $('.article-socials').length ) {
        socialSharing()
    }


    function contentTable() {
        if ( $("h3").length ) {
            const titles = $('h3');
            const mainTitle = $('h1.page-title');


            //table html

            const table = $('.privacy-table');
            const tableHeadingHtml = `<div class="content-table-heading">
                                        <span>Sections</span>
                                      </div>`;

            table.append(tableHeadingHtml);

            titles.each(function() {

                const title = $(this);
                // title.attr('data-anim-title', '')

                const titleText = title.text();
                const formatedToHref = titleText
                .replace(":", ' ')
                .replace(",", ' ')
                .replace("'", ' ')
                .replace(".", ' ')
                .replace(";", ' ')
                .replace("/", ' ')
                .replace("`", ' ')
                .replace("(", ' ')
                .replace(')', ' ')
                .replace(/^\s+|\s+$/gm,'')
                .replace(/ /g, '_')
                .toLowerCase()

                title.attr('data-anchor', formatedToHref);

                const tableRowHtml = `<div data-anchor="${formatedToHref}" class="content-table-row">
                                        <div class="content-table-link">
                                            <div class="hover-icon">
                                                <i></i>
                                                <i></i>
                                                <i></i>
                                            </div>
                                            <span>${titleText}</span>
                                        </div>
                                        <div class="content-table-row-arrow">
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0.85862 7.99978H15.0008M15.0008 7.99978L7.92969 0.928711M15.0008 7.99978L7.92969 15.0708" stroke="#fff"/>
                                            </svg>
                                        </div>
                                    </div>`;

                table.append(tableRowHtml);


            })


                setTimeout(function() {
                    const mainTitleHeight = mainTitle.outerHeight(true)
                    table.css({
                        "top": `${mainTitleHeight}px`,
                        "opacity": "1",
                        "visibility": "visible"
                    });
                },100)



            const tableRows = table.find('.content-table-row');

            tableRows.each(function() {
                const row = $(this);
                const attr = row.attr('data-anchor');

                const title = $(`h3[data-anchor="${attr}"]`);
                const titleTop = title.offset().top;


                row.on('click', function() {
                    scrollbar.scrollTo(0,( titleTop - 30 ), 3000);
                })
            })








        }
    }

    if ( $('.privacy').length &&  window.innerWidth > 1100 ) {
        contentTable()
    }



    function progressBarOnResize() {
        const prorgressBar = $('.progress-bar');

        prorgressBar.css('opacity', '0')
    }
    function animations() {


        const levelMarks = gsap.utils.toArray('.level')
        const baseAnimations = gsap.utils.toArray('[data-base-anim]')
        let cardAnimations = gsap.utils.toArray('[card-anim]')
        let cardOrder = gsap.utils.toArray('[card-group-anim]');
        let teamSlideInOut = gsap.utils.toArray('[team-member-anim]');
        let teamSlideInOutSpecTrigger = gsap.utils.toArray('[team-member-anim-trigger]');
        let titlesArray = gsap.utils.toArray('[data-anim-title]');

        let textP = document.querySelectorAll('[text-paragraph-anim]');
        let heightAnim = document.querySelectorAll('[height-anim]');


        gsap.to('.intro__bottom-btn', {
            delay: 3.5,
            transition: 1,
            autoAlpha: 1
        })
        gsap.to('.intro__wrapper-media', {
            delay: 1,
            transition: 1,
            autoAlpha: 1
        })

        gsap.set(levelMarks, {
            autoAlpha: 0,
        });

        gsap.set(cardOrder, {
            autoAlpha: 0,
            x: -500
        });

        gsap.set(cardAnimations, {
            autoAlpha: 0,
            rotationX: 50,

        });

        gsap.set(baseAnimations, {
            autoAlpha: 0,
        });

        levelMarks.forEach((el, i) => {
            gsap.to(el, {
                scrollTrigger: {
                    trigger: el,
                    pinType: 'transform',
                    start: "top 50%",
                },
                autoAlpha: 1
            })
        });

        heightAnim.forEach(wrapper => {
            const animImages = gsap.utils.toArray(wrapper.querySelector('img'))
            const containerHeight = wrapper.clientHeight;
            gsap.set(animImages, {
                height: 0,
            })

            animImages.forEach(img => {

                gsap.to(img, {
                    height: containerHeight,
                    duration: .8,
                    scrollTrigger: {
                        trigger: img,
                        pinType: 'transform',
                        start: "top 70%",
                    }
                })
            })

        });

        textP.forEach(inner => {

            const paragraphs = gsap.utils.toArray(inner.querySelectorAll('p'));

            gsap.set(paragraphs, {
                autoAlpha: 0,
            })

            paragraphs.forEach(p => {
                gsap.to(p, {
                    autoAlpha: 1,
                    duration: 1,
                    stagger: 1,
                    scrollTrigger: {
                        trigger: inner,
                        pinType: 'transform',
                        start: "top 60%",
                    }
                })
            })

        });

        teamSlideInOut.forEach((member, i) => {

            if ((i + 1) % 2 == 0  ) {
                gsap.set(member, {
                    autoAlpha: 0    ,
                    x: 500,
                })
            } else {
                gsap.set(member, {
                    autoAlpha: 0    ,
                    x: -500,
                })
            }

            gsap.to(member, {
                autoAlpha: 1,
                x: 0,
                duration: .5,
                scrollTrigger: {
                    trigger: member,
                    pinType: 'transform',
                    start: "top 50%",
                }
            })
        });

        teamSlideInOutSpecTrigger.forEach((member, i) => {

            if ((i + 1) % 2 == 0  ) {
                gsap.set(member, {
                    autoAlpha: 0    ,
                    x: 500,
                })
            } else {
                gsap.set(member, {
                    autoAlpha: 0    ,
                    x: -500,
                })
            }

            gsap.to(member, {
                autoAlpha: 0,
                x: 0,
                duration: 1.5,
                scrollTrigger: {
                    trigger: member,
                    pinType: 'transform',
                    start: "top 90%",
                }
            })
        });

        cardOrder.forEach(card => {
            gsap.to(card, {
                autoAlpha: 1,
                x: 0,
                stagger: 0.5,
                duration: .7,
                scrollTrigger: {
                    trigger: card,
                    pinType: 'transform',
                    start: "top 100%",
                }
            })
        });

        cardAnimations.forEach(card => {
            gsap.to(card, {
                autoAlpha: 1,
                rotationX: 0,
                duration: .8,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: card,
                    pinType: 'transform',
                    start: "top 70%",
                }  })

        });

        baseAnimations.forEach(base => {
            gsap.to(base, {
             autoAlpha: 1,
                duration: .5,
                scrollTrigger: {
                 trigger: base,
                 pinType: 'transform',
                 start: "top 60%",
                }
            })
        })

        titlesArray.forEach(title => {
            let splitTitle = new SplitText(title, {type: "words, chars"});
            let chars = splitTitle.chars;

            gsap.from(chars, {
                duration: 1.5,
                autoAlpha: 0,
                stagger: 0.1,
                y: 1000,
                ease: "power4.out",
                scrollTrigger: {
                    trigger: title,
                    start: "top 90%",
                    pinType: 'transform'
                }
            })
        })

        const $rays = gsap.utils.toArray('.wrapper-rays .wrapper-ray'),
            $raysReverse = $rays.reverse(),
         $header = $('.header'),
         $headerBtnParts = $('.header .btn-particles span, .intro .btn-particles span, button[type="submit"] .btn-particles span'),
         $introArrow = $('.intro__bottom-arrow');

        let headerBtnPartsTl,
            introArrowTl,
            headerTl,
            raysTl;


        headerTl = gsap.timeline();
        introArrowTl = gsap.timeline();
        raysTl = gsap.timeline();
        headerBtnPartsTl = gsap.timeline();

        $raysReverse.forEach(ray => {
            let rayOpacity;

            if ( ray.classList.contains('add--ray')) {
                rayOpacity = 1;
            } else {
                rayOpacity = 0.2
            }


            raysTl.staggerFromTo(ray, .7, {
                autoAlpha: 0,
            }, {
                autoAlpha: rayOpacity,
            }, 0.3)
        })

        headerTl.to($header, .7, {
            autoAlpha:1, delay: 1
        });

        introArrowTl.to($introArrow, {
            transition: 1,
            delay: 4,
            autoAlpha: 1,
            onComplete(){
                gsap.to($introArrow, {
                    y: 50,
                    ease: "none",
                    duration: 1,
                    opacity: 1,
                    repeat: -1,
                    yoyo: true,
                });
            }
        })

        headerBtnPartsTl.staggerFromTo($headerBtnParts, .4, {
            autoAlpha: 0, x: 100
        }, {
            autoAlpha: 1, x: 0, delay: 1, ease: "expo.out"
        }, 0.1);

        setTimeout(function () {
            introArrowTl.play()
            headerTl.play()
            headerBtnPartsTl.play()
        },1000)

        if ( $('.progress-bar').length ) {

            setTimeout(progressBarInit, 1000)
            $( window ).on( 'resize', function() {
                setTimeout(progressBarInit, 1000)
            });
        }


        //parralax

    }

    animations();

    $(window).on('resize', function (evt) {
        progressBarOnResize()
    })


    const borders = document.querySelectorAll( '.section-border:not(.no-anim-border), .solid-border' );
    function setPosBorders() {
        borders.forEach(item => {
            item.style.transform = 'translateY(' + item.clientHeight + 'px)';
        });
    }
    setPosBorders();
    $( window ).on('resize', function() {
        setPosBorders();
    });

    function setOffsetBorders() {
        const wh = window.innerHeight,
            whh = window.innerHeight / 2; // window height half
        borders.forEach(item => {
            const borderHeight = item.clientHeight,
                posStart = item.getBoundingClientRect().top - wh,
                posEnd = posStart + whh;

            if ( posStart < 0 && posEnd > 0 ) {
                const setTranslate = (1 - Math.abs(parseInt(posStart)) / whh) * borderHeight;
                item.style.transform = 'translateY(' + parseInt(setTranslate) + 'px)';
            } else if ( posEnd < 0 ) {
                item.style.transform = 'translateY(0)';
            }
        })
    }
    setOffsetBorders();

    if ( $( '.js-scroll > .scroll-content' ).length ) {
        scrollbar.addListener(({ offset }) => {
            setOffsetBorders();
        });
    } else {
        $( '.wrapper' ).on('scroll', function() {
            setOffsetBorders();
        });
    }
    $( window ).on('resize', function() {
        setOffsetBorders();
    });

    if ( $( '.map__frame svg' ).length ) {
        const step = 0.6;
        $( '.map__frame svg .points rect' ).each(function (i, item) {
            let cx = parseFloat($(this).attr('x')) + parseFloat($(this).attr('width')/2),
                cy = parseFloat($(this).attr('y')) + parseFloat($(this).attr('height')/2);
           $(this).css({
               'transform-origin': cx + 'px ' + cy + 'px',
               'animation-delay': i * step + 's'
           })
        });
    }

    let countServices,
        heightServices,
        maxHeightServices = 0,
        heightServicesList;

    let countValues,
        heightValues,
        maxHeightValues = 0,
        heightValuesList;

    function setServices() {
        $('.services__item').css('height', '');
        $('.services__item').each(function () {
            if (maxHeightServices < $(this).innerHeight()) {
                maxHeightServices = $(this).innerHeight();
            }
        });
        $('.services__item').css('height', maxHeightServices + 'px');

        countServices = $('.services__item').length;
        heightServices = $('.services__item').innerHeight();
        heightServicesList = maxHeightServices * countServices - maxHeightServices / 2;
        $('.services__list').innerHeight(maxHeightServices);
    }
    function setValues() {
        $('.values__item').css('height', '');
        $('.values__item').each(function () {
            if (maxHeightValues < $(this).innerHeight()) {
                maxHeightValues = $(this).innerHeight();
            }
        });
        $('.values__item').css('height', maxHeightValues + 'px');

        countValues = $('.values__item').length;
        heightValues = $('.values__item').innerHeight();
        heightValuesList = maxHeightValues * countValues - maxHeightValues / 2;
        $('.values__list').innerHeight(maxHeightValues);
    }

    setTimeout(function () {
        setServices();
        ScrollTrigger.create({
            trigger: '.services__content',
            pin: true,
            scrub: 0,
            start: 'top+=' + maxHeightServices / 2 + 'px center',
            end: 'top+=' + heightServicesList + ' center',
        });

        const services = gsap.utils.toArray('.services__item');

        services.forEach((section, i) => {
            const posStart = maxHeightServices * (i - 1) - maxHeightServices / 2,
                posEnd = posStart + maxHeightServices,
                opacityPosEnd = posStart + 50;

            if (i) {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: 'top+=' + posStart + 'px center',
                        end: 'top+=' + opacityPosEnd + 'px center',
                        scrub: 0,
                    },
                }).to(section, {
                    opacity: 1,
                });

                gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: 'top+=' + posStart + 'px center',
                        end: 'top+=' + posEnd + 'px center',
                        scrub: 0,
                    },
                }).to(section, {
                    rotateX: 0,
                });
            }
        });

        services.forEach((section, i) => {
            let posStart = maxHeightServices * i - maxHeightServices / 2,
                posEnd = posStart + maxHeightServices * (countServices - i - 1),
                minScale = 0.75,
                currentScale = minScale + (1 - minScale) / (countServices - 1) * i;

            if (i === 0) {
                posStart += maxHeightServices;
                posEnd = maxHeightServices * (countServices - i) - maxHeightServices / 2;
            }

            if (i < countServices - 1) {
                const currentOffset = maxHeightServices - maxHeightServices * currentScale + (countServices - i - 1) * 30;
                gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: 'top+=' + posStart + 'px center',
                        end: 'top+=' + posEnd + 'px center',
                        scrub: 0,
                    },
                }).to(section, {
                    scale: currentScale,
                    translateY: '-' + currentOffset,
                });
            }
        });
    }, 200);

    setTimeout(function () {
        setValues();
        ScrollTrigger.create({
            trigger: '.values__content',
            pin: true,
            scrub: 0,
            start: 'top+=' + maxHeightValues / 2 + 'px center',
            end: 'top+=' + heightValuesList + ' center',
        });

        const values = gsap.utils.toArray('.values__item');

        values.forEach((section, i) => {
            const posStart = maxHeightValues * (i - 1) - maxHeightValues / 2,
                posEnd = posStart + maxHeightValues,
                opacityPosEnd = posStart + 50;

            if (i) {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: 'top+=' + posStart + 'px center',
                        end: 'top+=' + opacityPosEnd + 'px center',
                        scrub: 0,
                    },
                }).to(section, {
                    opacity: 1,
                });

                gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: 'top+=' + posStart + 'px center',
                        end: 'top+=' + posEnd + 'px center',
                        scrub: 0,
                    },
                }).to(section, {
                    rotateX: 0,
                });
            }
        });

        values.forEach((section, i) => {
            let posStart = maxHeightValues * i - maxHeightValues / 2,
                posEnd = posStart + maxHeightValues * (countValues - i - 1),
                minScale = 0.75,
                currentScale = minScale + (1 - minScale) / (countValues - 1) * i;

            if (i === 0) {
                posStart += maxHeightValues;
                posEnd = maxHeightValues * (countValues - i) - maxHeightValues / 2;
            }

            if (i < countValues - 1) {
                const currentOffset = maxHeightValues - maxHeightValues * currentScale + (countValues - i - 1) * 30;
                gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: 'top+=' + posStart + 'px center',
                        end: 'top+=' + posEnd + 'px center',
                        scrub: 0,
                    },
                }).to(section, {
                    scale: currentScale,
                    translateY: '-' + currentOffset,
                });
            }
        });
    }, 200);

    $('.wrapper-ray-img').addClass('active');

    $(window).on('resize', function () {
        setServices();
        setValues();
    });

});
